import {IFileForm} from '../../interfaces/forms';
import {message as t} from '../messages';

const validFileTypes = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
];
const maxSizeMb = 5;

export const checkIsValidFile = (file: IFileForm) => {
  const size = file.size / (1024 * 1024);
  const included = validFileTypes.includes(file.type);

  if (!included) {
    return 'check-is-valid-file-type';
  }

  if (size > maxSizeMb) {
    return t('check-is-valid-file-size');
  }

  return true;
};
